"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ModalProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalProvider, _React$PureComponent);

  function ModalProvider() {
    var _this;

    _classCallCheck(this, ModalProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModalProvider).apply(this, arguments));

    _this.getCloseHandler = function (name) {
      return function () {
        return _this.props.onClose(name);
      };
    };

    return _this;
  }

  _createClass(ModalProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          components = _this$props.components,
          modals = _this$props.modals;
      var ModalComponents = [];

      for (var name in modals) {
        var modal = modals[name];

        if (!modal.open) {
          continue;
        }

        var Component = components[name];

        if (!Component) {
          throw new Error("Couldn't find a modal Component named \"".concat(name, "\""));
        }

        var onClose = this.getCloseHandler(modal.name);
        ModalComponents.push(React.createElement(Component, {
          key: name,
          name: name,
          metadata: modal.metadata,
          onClose: onClose
        }));
      }

      return React.createElement(React.Fragment, null, children, ModalComponents);
    }
  }]);

  return ModalProvider;
}(React.PureComponent);

exports.default = ModalProvider;
ModalProvider.defaultProps = {
  children: null
};